<template>
    <div id="login">
        <br>
		<span style="font-size: 18px; font-weight: normal!important;">Need an account?<a href="javascript:void(0)" @click="registerPage" style="color: #00aeef; font-weight: bold;"> Sign up.</a> 
        </span><br><br>
        <input type="email" placeholder="Email Address*" v-model="email" required>
        <span v-if="emailNotValid" style="color:red;">Enter a valid email.</span>
        <input type="password" placeholder="Password*" v-model="password" required>
        <span v-if="passwordNotValid" style="color:red;">Enter a valid password. That min length is 8</span>
        <a href="#" class="button2" @click="login"><div class="button">LOG IN</div></a>
    
        <div style="text-align: left; color:#00AAFF; font-weight: bold; padding-top: 10px; font-size: 18px"><a href="javascript:void(0)" @click="resetLinkRequestPage">Forgot Password?</a></div>
        <div style="font-weight: normal; text-align: left; font-size: 16px; padding-bottom: 15px; padding-top: 18px;">
          <p>These login credentials are different from your <br>
          SiriusXM Streaming credentials.</p>
          <p>Need  help? <a href="https://player.vimeo.com/video/499214859" target="new" style="font-weight: bold; color:#00AAFF;">Watch our support video.</a></p>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      email: null,
      emailNotValid: false,
      password: null,
      passwordNotValid: false,
 
    }
  },
  methods: {
    login() {
        if(this.email == "" || this.email == null){
            this.emailNotValid =true
            return
        }

        if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,15})+$/.test(this.email)) {
            this.emailNotValid = false
        }else{
            this.emailNotValid =true
            return
        }

        if(this.password == "" || this.password.lenth < 8){
            this.passwordNotValid = true
            return
        }

      const formData = {
        email: this.email,
        password: this.password
      };
      this.$store.dispatch("login", formData);
    },
    registerPage(){
        this.$router.push('/register')
        .catch(()=>{})
    },
    resetLinkRequestPage(){
      this.$router.push('/forgot-password').catch(()=>{})
    }
  },
  beforeCreate(){
    if(localStorage.getItem('currentUrl')){
      this.$store.dispatch('tryAutoLogin')
    }
  },
};
</script>

<style scoped>
@charset "utf-8";
/* CSS Document */

html, body {margin: 0px; background: #fff;}
body {font-family: 'Raleway', sans-serif; font-size: 16px; font-weight: 400; color: #231f20; word-break: keep-all; line-height: 26px;}
.mainheader {background: #fff; height: 112px; position: relative; width: 100%; border-top: solid 5px #00aeef;}



.logo a img {margin-top: 20px;}
.navigation {margin-top: 15px; float: right; max-width: 73%;}
.logo {max-width: 35%; float: left;}
span.phone {margin-right: 2.5em; font-size: 15px; font-weight: 700;}
span.phone a:before {content:"\f095"; display: block; float: left; font-family: "FontAwesome"; margin-right: 0.5em;}
span.phone a {color: #00aeef;}
span.account {float: right;}
a {color: #00aeef; text-decoration: none;}
a:hover {color: #00aeef; text-decoration: underline;}
.navigation ul li {display: inline-block; margin-right: 2.3em; position: relative; vertical-align: middle;}
.topnav ul li:last-child {margin-right: 0px;}
.navigation ul li a {font-size: 15px; color: #231f20; font-weight: bold;}
.navigation ul li a:hover {color: #00aeef; text-decoration: none;}
.mainnav a {font-size: 15px; color: #231f20; font-weight: bold;}
.mainnav {text-align: right;float: right; margin-bottom: 5px;}
a.button {background: #7ac143; color: #fff !important; padding: 10px 20px; border-radius: 4px; text-transform: uppercase;}
a.button:hover {background: #71b73a;}

center .dm-button, .newlocationcontain a, .inlinebutton a, .inlinebutton2 a,.inlinebutton3 a{
    padding: 10px; border: 1px solid #ccc; border-radius: 5px;
}
center .dm-button:hover, .newlocationcontain a:hover, .inlinebutton a:hover, .inlinebutton2 a:hover, .inlinebutton3 a:hover{
    padding: 10px; border: 1px solid #00aeef; border-radius: 5px; background-color: #eee
}
h1 {
    font-size: 32px;
    font-weight: 600;
    color: #00aeef;
}
h2 {font-size: 24px; font-weight: 400;}
div#Description.tabcontent h3 {color: #00aeef;}
.lt {float: left;}
.rt {float: right;}
.clr {clear: both;}
ul {line-height: 30px;}


div.breadcrumb2 {text-align: left; margin-top: -25px; margin-bottom: 40px; text-transform: uppercase;}
.shopheader {float: left; background: #00aeef; width: 100%;}
.leftnav {font-size: 15px; color: #fff; width: 60%; float: left;}
.leftnav ul {padding-left: 0px; margin: 10px 0px;}
.leftnav ul li {display: inline-block; margin-right: 2.3em; position: relative; vertical-align: middle;}
.leftnav ul li a {text-transform: uppercase; font-weight: 500; color: #fff; display: inline-block;}
.rightnav {font-size: 15px; color: #fff; width: 40%; float: right;}
.navtext {text-align: right; margin-top: 13px;}
.navtext a {color: #fff;}
.navtext img {vertical-align: top; margin-left: 8px;}

/*.cta {width: 100%; background:url(images/cta-bg.jpg); padding: 40px 0px;}*/
.cta h1 {color: #fff; font-size: 45px; font-weight: 500;}
.cta h2 {color: #fff; font-size: 32px;}
.price {font-size: 40px; font-weight: 500; color: #fff; margin-bottom: 25px; margin-top: 15px;}
span.month {font-size: 30px;}

.bluetextbar {float: left;background: #00aeef; color: #fff; font-size: 24px; width: 100%; text-align: center; padding: 20px 0px;}
.bluetextbar a {color: #fff; text-decoration: underline;}

.bluetextbar2 {float: left;background: #00aeef; color: #fff; font-size: 20px; width: 100%; text-align: center; padding: 15px 0px;}
.bluetextbar2 a {color: #fff; text-decoration: underline;}

.radios {width: 30%; float: left; margin-right: 5%; margin-bottom: 24px;}
.radios:nth-child(3),.radios:nth-child(6),.radios:nth-child(9) {margin-right: 0px;} 

/*.radios:last-child {margin-top: 20px; margin-right: 0px;}*/
.radios2 {width: 30%; float: left; margin-right: 5%; margin-bottom: 24px;}
/*.radios:last-child {margin-right: 0px;}*/

.radios2:last-child {margin-top: 0px;}

div.radiotitle {display: block; color: #00aeef; font-size: 20px; font-weight: 500; margin-bottom: 10px;}
span.modelnumber {display: block; font-weight: 500;}
span.pricing {color:  #00aeef; display: inline-block; font-weight: 500; font-size: 24px;}
span.msrp {display: inline-block; font-size: 18px;}
span.save {color: #ed1c24; font-weight: 500; text-transform: uppercase;}

.button {width: 100%; background-color: #00aeef; color: #fff; border-radius: 4px; text-align: center; padding: 10px 0px 12px; font-size: 20px; font-weight: 400; margin-top: 20px;}
.button:hover, .button2:hover  {opacity: 0.7;}
.button2 a {
	font-size: 16px;
    background-color: #00aeef;
    border-width: 0px!important;
    border-radius: 5px;
    font-weight: bold;
    font-style: normal;
    text-transform: none;
    text-decoration: none;}

.radios img {text-align: center;}
/*.radios ul {list-style:url(images/check.png) outside; margin-top: 15px; margin-bottom: 25px; padding-left: 20px;}*/

.radios2 img {text-align: center;}
/*.radios2 ul {list-style:url(images/check.png) outside; margin-top: 15px; margin-bottom: 25px; padding-left: 20px;}*/

/*.linksection {float: left; background-image:url(images/plankbggrey.png); width: 100%; padding: 60px 0px 80px 0px;}*/
.linksection .radios {text-align: center;}
.button2 {width: 100%; background-color: #00aeef; color: #fff; border-radius: 4px; text-align: center; padding: 10px 0px 12px; font-size: 20px; font-weight: 500; margin-top: 20px; cursor: pointer;}
.button2:hover {background-color: #00A5E3;}

.linksection .radios2 {text-align: center;}




.wallofsound {float: left; background:rgb(18, 67, 99); width: 100%; padding: 60px 0px 80px 0px;}
.wallofsound h1 {color: #fff;}
.wallofsound h2 {color: #fff;}

/* entire container, keeps perspective */
.flip-container {
	perspective: 1000px;
	transform-style: preserve-3d;
}
	/*  UPDATED! flip the pane when hovered */
	.flip-container:hover .back {
		transform: rotateY(0deg);
	}
	.flip-container:hover .front {
	    transform: rotateY(180deg);
	}

.flip-container, .front, .back {
	width: 173px;
	height: 110px;
}

/* flip speed goes here */
.flipper {
	transition: 0.6s;
	transform-style: preserve-3d;

	position: relative;
}

/* hide back of pane during swap */
.front, .back {
	backface-visibility: hidden;
	transition: 0.6s;
	transform-style: preserve-3d;

	position: absolute;
	top: 0;
	left: 0;
}

/*  UPDATED! front pane, placed above back */
.front {
	z-index: 2;
	transform: rotateY(0deg);
background: #005581; height: 75px; border-radius: 10px; padding: 19px; text-align: center; margin-right: -20px;
}

/* back, initially hidden pane */
.back {
	transform: rotateY(-180deg);
background: #005581; height: 75px; border-radius: 10px; padding: 19px; text-align: center; margin-right: -20px; color: #fff;
}

/* 
	Some vertical flip updates 
*/
.vertical.flip-container { 
	position: relative;
}

	.vertical .back {
		transform: rotateX(180deg);
	}

	.vertical.flip-container:hover .back {
	    transform: rotateX(0deg);
	}

	.vertical.flip-container:hover .front {
	    transform: rotateX(180deg);
	}

.back h2 {color: #fff; font-size: 16px; margin-top: 4px;}

.chanflip {float: left; height: 90px; width: 205px; margin-right: 15px; margin-bottom: 32px; cursor: pointer !important;} 
.chanflip img {width: 150px;}

a.tablinks.green {background-color:rgba(122, 193, 67, .35) !important; color: #fff !important;}
a.tablinks.ltblue {background-color:rgba(0, 174, 239, .35) !important; color: #fff !important;}
a.tablinks.orange {background-color:rgba(247, 148, 30, .35) !important; color: #fff !important;}
a.tablinks.purple {background-color:rgba(129, 41, 144, .35) !important; color: #fff !important;} 


div.wallofsound ul.tab li a.tablinks.green:hover {background-color: #7ac143 !important; color: #fff !important;}
div.wallofsound ul.tab li a.tablinks.ltblue:hover {background-color: #00aeef !important; color: #fff !important;}
div.wallofsound ul.tab li a.tablinks.orange:hover {background-color: #f7941e !important; color: #fff !important;}
div.wallofsound ul.tab li a.tablinks.purple:hover {background-color: #812990 !important; color: #fff !important;}

div.wallofsound ul.tab li a.tablinks.green.active {background-color: #7ac143 !important; color: #fff !important;}
div.wallofsound ul.tab li a.tablinks.ltblue.active {background-color: #00aeef !important; color: #fff !important;}
div.wallofsound ul.tab li a.tablinks.orange.active {background-color: #f7941e !important; color: #fff !important;}
div.wallofsound ul.tab li a.tablinks.purple.active {background-color: #812990 !important; color: #fff !important;}
 

/* Style the list */
div.wallofsound ul.tab {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
}

div.wallofsound ul {list-style: none !important;}

/* Float the list items side by side */
div.wallofsound ul.tab li {float: left; margin: 0px 15px 20px 0px !important}

/* Style the links inside the list items */
div.wallofsound ul.tab li a {
    display: inline-block;
    color: black;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    transition: 0.3s;
    font-size: 17px;
	border-radius: 4px;
	border: solid 2px #fff;
	font-weight: 700;
	text-transform: uppercase;
}

/* Style the tab content */
div.wallofsound .tabcontent {
    display: none;
}

div.wallofsound ul.tab li a:focus, .active {}

.play {background: transparent; cursor: pointer; width: 32px; height: 32px; border: none; position: relative;}
.play img {width: 32px; height: 32px;}
.play:focus {outline: none !important;}

div.channellink {text-align: center; width: 100%; margin-top: 20px;}

.footer {float: left; width: 100%; padding: 60px 0px 80px 0px;}
.contactleft {float: left; width: 40%}
.contactright {float: right; width: 51%;}

div.service-icon {width: 50px; margin-right: 10px; float: left;}
div.service-icon2 {float: left; padding-bottom: 35px;}
div.service-icon2:last-child {padding-bottom: 0px;}
div.questions {margin-top: -25px;}

.bottomfooter {float: left; width: 100%; padding: 60px 0px 60px 0px; background:#161616;}
div.footer-sections {border-left: 1px solid #7C7C7C; padding: 0 0 0 12px; width: 15.5%; margin-right: 4%; float: left; height: 255px;}
.footer-sections hr, .footer-sections2 hr {border: 1px solid #4d4d4d;}
div.footer-sections2 {border-left: 1px solid #7C7C7C; padding: 0 0 0 12px; width: 15.5%;float: left; height: 255px;}
div.footer-sections3 {width: 16.5%; margin-right: 4%; float: left;}
div.footer-content {font-family:'Raleway';}
div.footer-sections h2 {color: #7C7C7C; margin-top: 0px; font-weight: bold; font-size: 15px;}
div.footer-sections2 h2 {color: #7C7C7C; margin-top: 0px; font-weight: bold; font-size: 15px;}
div.footer-sections a, div.footer-sections2 a {color: #7C7C7C; font-size: 14px; line-height: 26px; display: block; font-weight: normal!important;}

.bottom-bar {float: left; width: 100%; padding: 0px 0px 30px 0px; background: #3f3f3f;}
.site-info {
    color: #CCCCCC;
    font-size: 14px;
    width: 350px;
	text-align: center;
	margin: auto;
}
.bottom-bar-menu {text-align: right; color: #4896d0; float: right; width: 40%;}
.bottom-bar-menu a {
    color: #ccc;
    font-size: 14px;
}

/*.ctaproduct {float: left; width: 100%; background:url(images/product-bg.jpg); padding: 40px 0px 60px;}*/
.ctaproduct h1 {color: #fff; font-size: 50px; font-weight: 500;}
.ctaproduct h2 {color: #fff; font-size: 30px; line-height: 34px;}
/*.ctaproduct ul {color: #fff; font-size: 20px; line-height: 35px; list-style:url('images/bull_right.png') outside; padding-left: 0px; margin-left: 22px; margin-top: 15px; margin-bottom: 25px;}*/
.productbutton {width: 65%;}
.productbutton .button {font-size: 25px; padding: 15px 0px;}

.productbutton2 {width: 100%;}
.productbutton2 .button {font-size: 25px; padding: 15px 0px;}

img.productimg {margin-right: 30px; width: 133px; margin-top: 20px;}
img.productimg:last-child {margin-right: 0px;}

.producttext {width: 55%; float: left;}
.producttext2 {width: 45%; float: right;}
.producttext2 img {float: right;}

.column {width: 48%; border-right: solid 1px #a1a1a1; padding-right: 45px; float: left;}
.column2 {width: 43%;}

.heading {width: 60%; float: left;}
.crumbs {text-align: right; width: 40%; float: right;}

/* Style the list */
ul.tabspecs {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    border: 1px solid #ccc;
    background-color: #f1f1f1;
}

/* Float the list items side by side */
ul.tabspecs li {float: left;}

/* Style the links inside the list items */
ul.tabspecs li a {
    display: inline-block;
    color: black;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    transition: 0.3s;
    font-size: 16px;
	font-weight: 500;
}

/* Change background color of links on hover */
ul.tabspecs li a:hover {background-color: #ddd; color: #231f20 !important;}

/* Create an active/current tablink class */
ul.tabspecs li a:focus, .active {background-color: #00aeef; color: #fff !important;}

/* Style the tab content */
.tabspecscontent {
    display: none;
    padding: 6px 12px;
    border: 1px solid #ccc;
    border-top: none;
}
sup {position: absolute;}
.text-description img {width: 30px; margin-left: -50px; position: absolute; }
div.pricing {margin: 0 auto;}
div.pricetitle {width: 50%; font-size: 21px; float: left;line-height: 32px; margin: 30px 0px;}
div.pricetitle2 {width: 25%; float:right; font-size: 21px; font-weight: 700; margin: 30px 0px;line-height: 32px;}

.crumbs ul li {display: inline;}
.crumbs ul li::after {content: "\f0da"; padding: 0px 10px; font-family: "FontAwesome"}
.crumbs ul li:last-child::after {content: none;}

table.compare {text-align: center; border: 1px solid #eaeaeb; margin: 0 0 1.78571em; width: 100%; border-collapse: collapse; border-spacing: 0;}
table.compare th, table.compare td {border: 1px solid #dcdcdc; padding: 0.75em;}
table.compare h2 {font-size: 24px; margin: 10px 0px;}


/* BEGIN shopping cart page */
.cartitem {float: left; border: 2px solid #00AEEF; border-radius: 4px; width: 100%; margin-bottom: 25px;}
.cartimage {float:left; text-align:center; width: 130px; padding: 20px 30px; margin-right: 20px;}
.cartproductinfo {float:right; width: 36%; margin-right: 3%;}
.cartproductinfo2 {
    float: left;
    width: 80%
}
.cartproductinfo2ks {float:left; width:80%}
.cartproductinfo2ksb {float:left; width: 15%}
.cartproductinfo3 {float:left; width: 28%; margin-right: 3%;}
.cartproductinfo4 {float:left; width: 65%; }
.cartproductinfo4 .newlocationcontain {float: left; width: 100%;}
.cartproductinfo4 .newlocationcontain .newlocation select {width: 102%;}
.cartproductinfo4 .newlocationcontain .newlocation2 select {width: 102%;}
.cartprice {float:left; text-align:center; padding-top: 32px; width: 12.5%;}
.cartqty {float:left; text-align:center; padding-top: 18px; width: 12.5%;}
.cartqty input {width: 36px; text-align:center; padding-left: 17px;}
.cartextprice {float:left; text-align:center; padding-top: 32px; width: 12.5%; font-weight: bold;}
.cartsubtotal {text-align:right; font-size: 21px; font-weight:bold; margin-bottom: 16px;}
.rightalign {text-align:right;}
.buttoncontainer .button {width: 30%; float: left; margin: 0px 110px;}
.cartRadioLabel {display: inline-block; width: 155px; border: 2px solid #00AEEF; border-radius: 4px; text-align:center; color: #00AEEF; background-color: white; user-select:none; line-height: 24px; padding: 15px 0px;}
.cartRadioLabel:hover {cursor:pointer;background-color:#E0F0FF;}
.cartRadioLabelCF {display: inline-block; vertical-align: top; width: 155px; border: 2px solid #00AEEF; border-radius: 4px; text-align:center; color: #00AEEF; background-color: white; user-select:none; line-height: 24px; padding: 27px 0px;}
.cartRadioLabelCF:hover {cursor:pointer;background-color:#E0F0FF;}
.cartRadioButton {display: none;}
.cartRadioButton:checked + label {background-color: #00AEEF; color: white;}
td.cartWarrantyContainer {padding:0 !important;}
/*.cartWarrantyLabel {display: inline-block; width: 266px; border: 2px solid #00AEEF; border-radius: 4px; text-align:center; color: #00AEEF; background-color: white; user-select:none; line-height: 24px; padding: 15px 0px;}*/
.cartWarrantyLabel:hover {cursor:pointer;background-color:#E0F0FF;}
.cartWarrantyLabel1 {display: inline-block; width: 318px; border: 2px solid #00AEEF; border-radius: 4px; text-align:center; color: #00AEEF; background-color: white; user-select:none; line-height: 24px; padding: 15px 0px;}
.cartWarrantyLabel2 {display: inline-block; width: 155px; border: 2px solid #00AEEF; border-radius: 4px; text-align:center; color: #00AEEF; background-color: white; user-select:none; line-height: 24px; padding: 15px 0px;}
td.cartWarrantyIcon {width:35px; text-align: center; vertical-align: top;}
td.cartWarrantyIcon div img {width: auto; height: auto;}
.inlinebutton {margin-top: 10px;}
.inlinebutton2 {margin-top: 20px;}
.inlinebutton3 {
    margin-top: 15px;
    width: 15%;
    float: left;
}

/* Popup container */
.popup {
    position: relative;
    display: inline-block;
    cursor: pointer;
}

/* The actual popup (appears on top) */
.popuptext {
    cursor: pointer;
    width: 100%;
    height: 545px;
    top: 220px;
    position: absolute;
    display: none;
    background-color: #656565;
    color: #fff;
    left: 380px;
}

/* Popup arrow */
/*.popup .popuptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
}*/

/* Toggle this class when clicking on the popup container (hide and show the popup) */
.show {
    
    display: block;
    -webkit-animation: fadeIn 0.1s;
    animation: fadeIn 0.1s
}

/* Add animation (fade in the popup) */
@-webkit-keyframes fadeIn {
    from {opacity: 0;} 
    to {opacity: 1;}
}

@keyframes fadeIn {
    from {opacity: 0;}
    to {opacity:1 ;}
}

h3.nobottom {margin-bottom: 5px;}
table.popup2 {border: 1px solid #eaeaeb; width: 100%; border-collapse: collapse; border-spacing: 0;}
table.popup2 th, table.popup2 td {border: 1px solid #dcdcdc; padding: 0.75em;}
table.popup2 h2 {font-size: 24px;}
.popuptext2 {width: 700px; background-color:rgba(123,123,123,1); color: #fff; border-radius: 4px; padding: 30px; margin-left: -350px; left: 50%; margin-top: -230px; top: 50%; height: auto;}
/* END shopping cart page */

#accountContainer {width: 40%;}
.accountButton {width: 35%; text-align:center; float:left;}

/* BEGIN review page */
.reviewLineItem {float:left; border: 2px solid #00AEEF; border-radius: 4px; width: 100%; margin-bottom: 10px;}
.reviewImage {float:left;text-align:center;width:20%;}
.reviewImage img {text-align:center; max-height: 100px; max-width: 100px; height: auto; width: auto;padding-top:16px;}
.reviewPartInfo {float:left;text-align:center;padding-top:38px; width:35%}
.reviewPrice {float:left; text-align:center; padding-top: 24px; width: 45%;}
.reviewTodaysPrice {text-align:center; width: 33.3%;float:left;}
.reviewQuantity {text-align:center; width: 33.3%;float:left;}
.reviewTodaysExtPrice {text-align:center; width: 33.3%; font-weight:bold;float:left;}
.reviewSiteSubtotal {float:right;font-weight:bold;margin-right:10px;}

.reviewShipping {float:left;width:70%}
.reviewShipToAddress {text-align:center;padding:18px 0px 18px 24px;}
.reviewShipAddressInfo {text-align:left; font-size: 20px;}
#formShippingOption select {width: 50%;}

.reviewTotals {float:right;width:30%;}
.reviewPricing {float:right;}
.reviewSavings {float:right;color:red;}
.reviewTotal {float:right;font-weight:bold;font-size:20px;}
/* END review page */

.starthidden {display: none;}
.errorlist {display: none;}
#ulErrors {width:95%; color: #bf0000; border: solid 1px #bf0000; padding: 20px 0px 20px 47px; border-radius: 4px; text-align: left;}
#divOrderProcessing {display: none;}
.nowrap {white-space: nowrap; font-weight: bold;}
.errorHighlight {border:solid 1px #bf0000;}
#ulErrors li {border:none !important;}
.formdata {display:none;}
.spanProcessing {display:none; text-align: center; vertical-align: central; color: #00aeef; font-style: italic;}
#ulContactUsErrors {width:95%; color: #bf0000; border: solid 1px #bf0000; padding: 20px 0px 20px 47px; border-radius: 4px; text-align: left;}
#ulContactUsErrors li {border:none !important;}

.newInfo {display:none;}
.newInfo .button2 {width: 25%;}
.addNew {text-align:center;margin: 4px 0px 16px 0px;font-weight:bold;}
.cartsitedropdown {float: right; width: 37%; padding: 30px 30px 30px 0px;}

.prevStep {float: left; width: 25%;}
.nextStep {float: right; width: 25%;}

.col1, .col2, .col31, .col32, .col33 {float:left;}
.col1 {margin-right: 5%; width:45%}
.col2 {width: 45%;}
.col31, .col32, .col33 {width: 33.3%;}

input {
    color: #000;
    padding-left: 20px;
    height: 45px;
    width: 95.5%;
    border-radius: 5px;
    background-color: #eee;
    border: 1px solid #CCCCCC;
    margin-bottom: 18px;
    font-size: 16px;
    font-family: inherit;
}
input:focus, select:focus {
    outline-offset: -2px;
    outline: #00aeef auto 5px!important;
}
input::placeholder {color: #7c7c7c;}

input::-webkit-input-placeholder { /* Chrome/Opera/Safari */ 
  color: #7c7c7c;
}
input::-moz-placeholder { /* Firefox 19+ */
  color: #7c7c7c;
}
input:-ms-input-placeholder { /* IE 10+ */
  color: #7c7c7c;
}
input:-moz-placeholder { /* Firefox 18- */
  color: #7c7c7c;
}
select {color:#7c7c7c; padding-left: 20px; height: 47px; width: 100%; border-radius: 4px; background-color: #eee; border: solid 1px #ccc!important; margin-bottom: 18px; font-size: 16px; font-family: inherit;}
input.checkbox {width: 20px; color: #00aeef; height: 20px; margin: 0px 15px 15px 0px;padding: 0px;}

div.infobox {margin-bottom: 20px; display: inline-block; width: 96%; border: solid 2px #ccc; border-radius: 4px; padding: 20px;}
.ajax-icon {float: left; margin-right: 16px;}
.ajax-text {margin-top: 5px;}
#accountContainer h1 {margin-top: 0px;}
form#formLocations, form#formBillingInfo, form#formShippingLocation {margin-top: 20px;}
form#formNewBillingInfo, form#formNewShippingLocation, form#formShippingOption, .reviewTotals {margin-bottom: 20px;}
div.col3 {width: 27%; display: inline-block; margin-right: 8%; float: left;}
div.col4 {width: 27%; margin-right: 0%; float: left;}

div.comparelink {text-align: center; margin-top: 25px;}

table.pricing h1 {text-align: left; font-size: 20px; margin-bottom: 0px; margin-top: 0px; font-weight: 500;}
table.pricing {width: 100%; text-align: center;}

div.cartheading {width: 40%; float: left;}
div.cartbuttons {width: 25%; float: right; margin-right: 2%; margin-bottom: 25px;}
div.cartbuttons2 {width: 25%; float: right; margin-right: 0%;}
div.cartsummary {width: 55%; float: left; padding: 30px;}
div.cartsummary2 {border: 2px solid #00aeef; border-radius: 4px;width: 30%; float: left; padding: 15px 30px; margin: 20px;}

div.cartsummary2 h1 {font-size: 26px; font-weight: 500; color:  #00aeef;}
table.cart {width: 100%;}
table.cart h2 {font-size: 24px;}
table.cart2 {width: 100%; border-collapse: collapse;}
table.cart2 h1 {margin-top: 0px; font-size: 22px;}
table.cart2 h2 {margin-top: 0px; font-size: 22px; font-weight: 500;}
table.cart2 img {width: 130px;}
div.shopprice {font-size: 26px; font-weight: 500;}
table.cart2 tr {border-bottom: solid 2px #dadada;}
table.cart2 tbody tr td {padding: 15px 0px;}
table.cart2 .cartqty {width: 100%; text-align: center; padding-top: 0px;}



div.cartproductinfo2 h2 {margin-bottom: 5px; font-size: 20px; font-weight: 500;}
div.cartproductinfo h2 {margin-bottom: 5px; font-size: 20px; font-weight: 500;}
div.cartproductinfo3 h2 {margin-top: 0px; margin-bottom: 5px; font-size: 20px; font-weight: 500;}
div.cartproductinfo4 h2 {margin-top: 0px; margin-bottom: 5px; font-size: 20px; font-weight: 500;}
div.productTitle {margin-bottom: 10px;}

div.newlocation {width: 48%; float: left;}
div.newlocation2 {width: 48%; float: right;}
div.newlocationcontain {
    width: 78%;
    float: right;
    margin: auto;
}
div.newlocationcontain3 {
    width: 78%;
    margin: auto;
}
div.newlocationcontain2 {
    width: 95%;
    float: left;
    margin-left: 3%;
}

h2.headline {margin: 3%; font-size: 22px; font-weight: 500; margin-top: 30px; margin-bottom: 10px;}
.nextStep {margin-bottom: 60px;}
div.billing {margin-left: 3%; margin-right: 3%;margin-top: 3%;}
div.review {margin: 3%;}
img.cards {position: absolute; margin-top: -60px; margin-left: 190px;}

div.cartheading2 {width: 60%; float: left;}
div.smallsummary {float: right; width: 25%; padding: 20px 25px; border: solid 2px #00aeef; border-radius: 4px; margin-bottom: 20px;}
.smallsummary h1 {margin-top: 0px; font-size: 22px; color: #00aeef; font-weight: 500;}
table.smallsummary {width: 100%; font-size: 18px; font-weight: 500;}

tr.total {font-weight: 500;}
div.totalnumber {font-weight: 500; font-size: 22px; text-align: right;}
div.ordertotal {width: 25%; float: right; padding-top: 10px;}
div.checkboxes {width: 75%; float: left;}
table.ordertotal {width: 100%; font-size: 26px; font-weight: 500; color: #00aeef;}
div.breadcrumb {
    text-align: center;
    width: 100%;
    font-weight: 300;
    padding-bottom: 50px;
}
div.breadcrumb a {font-weight: bold;}

table.billinginfo {width: 100%;}
table.billinginfo tbody tr {vertical-align: top;}

div.headinghalf {float: left;}

div#warrantyPopup2 {width: 1160px; margin-left: -580px; margin-top: -265px;}

div.app {width: 60%; margin-right: 5%; float: left;}
div.app2 {width: 35%; float: left;}
div.app img, div.app2 img {max-width: 100%;}
div.apphalf {width: 45%;}
span.new {color: #812990;}

/* Style the shop tab */
div.shoptab {
    overflow: hidden;
    border-bottom: 1px solid #005581;
	margin-bottom: 35px; 

}

/* Style the buttons inside the shop tab */
div.shoptab button {
    background-color: inherit;
    float: left;
    border: none;
	background-color: #cfd4d8;
    outline: none;
    cursor: pointer;
    padding: 14px 20px;
	font-family: 'Raleway';
	font-size: 16px;
    transition: 0.3s;
	margin-right: 5px;
	border-top-left-radius: 10px; border-top-right-radius: 10px;
}

/* Change background color of buttons on hover */
div.shoptab button:hover {
    background-color: #00aeef;
	color: #fff;
}

/* Create an active/current tablink class */
div.shoptab button.active {
    background-color: #005581;
}

/* Style the tab content */
.shopcontent {
    display: none;
    border-top: none;
}

/* Add a black background color to the top navigation */
.clear{ clear: both;}
.menu_header{
    background-color: #000000;
    align-content: center;
    height: auto;
    position: fixed;
    top: 0;
    width: 100%;
}



/* Add an active class to highlight the current page */
.active {
  background-color: #000000;
  color: #9e9e9e!important;
}

/* Hide the link that should open and close the topnav on small screens */
.topnav .icon {
  display: none;
}

/* Dropdown container - needed to position the dropdown content */
.dropdown {
  float: left;
  overflow: hidden;
}

/* Style the dropdown button to fit inside the topnav */
.dropdown .dropbtn {
  font-size: 14px;
  border: none;
  outline: none;
  color: white;
  padding: 14px 16px;
  background-color: inherit;
  font-family: inherit;
  margin: 0;
}

/* Style the dropdown content (hidden by default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
}

/* Style the links inside the dropdown */
.dropdown-content a {
  float: none;
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  text-align: left;
}

/* Add a dark background on topnav links and the dropdown button on hover */
.topnav a:hover, .dropdown:hover .dropbtn {
  color: #9e9e9e!important;
	opacity: 0.7;
}

/* Add a grey background to dropdown links on hover */
.dropdown-content a:hover {
  background-color: #ddd;
  color: black;
}

/* Show the dropdown menu when the user moves the mouse over the dropdown button */
.dropdown:hover .dropdown-content {
  display: block;
}

/* When the screen is less than 600 pixels wide, hide all links, except for the first one ("Home"). Show the link that contains should open and close the topnav (.icon) 
@media screen and (max-width: 600px) {
  .topnav a:not(:first-child), .dropdown .dropbtn {
    display: none;
  }
  .topnav a.icon {
    float: right;
    display: block;
	  color: #00aeef!important;
  }
	.topnav {float: left;}
}
*/
/* The "responsive" class is added to the topnav with JavaScript when the user clicks on the icon. This class makes the topnav look good on small screens (display the links vertically instead of horizontally) 
@media screen and (max-width: 600px) {
  .topnav.responsive {position: relative;}
  .topnav.responsive a.icon {
    position: absolute;
    right: 0;
    top: 0;
  }
  .topnav.responsive a {
    float: none;
    display: block;
    text-align: left;
  }
  .topnav.responsive .dropdown {float: none;}
  .topnav.responsive .dropdown-content {position: relative;}
  .topnav.responsive .dropdown .dropbtn {
    display: block;
    width: 100%;
    text-align: left;
  }

.topnav {float: left;}
	}
*/
/* Popup container */
#new_location {
    width: 90%;
    margin: 10% 5% 10% 5%;
    display: none;
    background-color: #FFFFFF!important;
    border-radius: 10px!important;
    padding: 25px;
    z-index: 99;
    top: 0;
    position: absolute;
    -webkit-box-shadow: 10px 5px 10px;
    box-shadow: 5px 5px 10px;
    border: 1px solid #CCCCCC;
}
#new_location2 {
	width: 90%;
	margin: 10% 5% 10% 5%;
  display: none;
  background-color: rgba(0,0,0,0.85)!important;
  border-radius: 10px!important;
  padding: 25px;
  z-index: 99;
	top: 0;
    position: absolute;

}
#infopopup {
	width: 50%;
	margin: 10% 25% 10% 25%;
  display: none;
  background-color: rgba(0,0,0,0.85)!important;
  border-radius: 10px!important;
  padding: 25px;
  z-index: 99;
	top: 0;
    position: absolute;

}

/* The actual popup (appears on top) */
.newpop-location {
    color: #000000;
    text-align: center;
}
.newlocation dl, .newlocation2 dl{font-size: 12px; margin: -15px 0px 10px 0px; color: #ccc; text-align: left; }
.newlocation dt, .newlocation2 dt {text-align: left; font-weight: bold; font-size: 14px;}
.smallOrg a{font-size: 14; color: #F99400;}
.fa-question-circle {
    font-size: 16px;
    vertical-align: super;  
}
.shiping {text-align: left;}
.shiping p {text-align: left; margin-top: -12px; font-size: 14px;}
.subhead{
    padding-bottom: 15px;
    font-size: 18px;
}
.closex {width: 25px; float: right; text-align: center; border: 1px solid #00aeef;}
.closex a:hover{color: red;}

.is-blurred > *:not(#new_location){
-webkit-filter: blur(2px);
-moz-filter: blur(2px);
-o-filter: blur(2px);
-ms-filter: blur(2px);
filter: blur(2px);    
}
.is-blurred2 > *:not(#new_location2){
-webkit-filter: blur(2px);
-moz-filter: blur(2px);
-o-filter: blur(2px);
-ms-filter: blur(2px);
filter: blur(2px);    
}

/**test dropdown**/

.s-hidden {
    visibility:hidden;
    padding-right:10px;
}
.select {
    cursor:pointer;
    display:inline-block;
    position:relative;
    color:#7c7c7c; padding-left: 20px; height: 47px; width: 100%; border-radius: 4px; background-color: #eee; border: solid 1px #ccc!important; margin-bottom: 18px; font-size: 16px; font-family: inherit;
}
.styledSelect {
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
   padding: 10px; 
	font-weight: normal;
	background-color:#f2f2f2;
	border: solid 1px #ccc!important;

}
.styledSelect:after {
    content:"";
    width:0;
    height:0;
    border:5px solid transparent;
    border-color:#ccc transparent transparent transparent;
    position:absolute;
    top:9px;
    right:6px;
}
.styledSelect:active, .styledSelect.active {
    background-color:#eee;
}
.options {
    display:none;
    position:absolute;
    top:100%;
    right:0;
    left:0;
    z-index:999;
    margin:0 0;
    padding:10px 0px 10px 0px;
    list-style:none;
    border:1px solid #ccc;
    -webkit-box-shadow:0 1px 2px rgba(0, 0, 0, 0.2);
    -moz-box-shadow:0 1px 2px rgba(0, 0, 0, 0.2);
    box-shadow:0 1px 2px rgba(0, 0, 0, 0.2);
		background-color:#f2f2f2;
	font-weight: normal;

}
.options li {
    padding:0 6px;
    margin:0 0;
    padding:5px 10px;
}
.options li:hover {
    background-color:#00aeef;
    color:#fff;
}
/* Desktop */
@media all and (min-width: 981px) {
.topnav {text-align: right; float: right;}
	.header_image{
    float: left;
    padding-top: 20px;
    padding-right: 0px;
    padding-bottom: 0px;
    padding-left: 18%;
}
	.topnav {
    background-color: #000;
    float: right;
    overflow: hidden;
    padding-top: 10px;
    padding-bottom: 0px;
    padding-left: 10px;
    padding-right: 15%;
}

/* Style the links inside the navigation bar */
.topnav a {
  float: left;
  display: block;
  color: #9e9e9e!important;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 13px;
	font-family: 'Raleway';
	font-weight: bold;
}
	div.login {width: 45%; float: left;margin-right: 4%; padding-bottom: 60px;}
div.login2 {float: left; width: 45%; padding-left: 4%; border-left: solid 2px #dadada; margin-top:90px; padding-left: 0px; padding-bottom: 0px;}

	.mainsection {
    float: left;
    width: 100%;
    padding-top: 120px;
    padding-right: 0px;
    padding-left: 0px;
}
	.container {
    width: 1100px;
    margin: 0 auto;
    font-size: 14px;
    font-weight: bold;
    color: #231f20;
}
	.bottom-bar2{background-color:#000; padding: 15px 40px 20px 40px; position:fixed;
    bottom:0; width: 100%;}
}


/* Mobile */
@media all and (max-width: 980px) {
.topnav {text-align: center; margin: auto; width: 400px;}
.header_image{
    float: none;
    padding-top: 20px;
    text-align: center;
}
	.topnav {
    background-color: #000;
    padding-top: 10px;
    padding-bottom: 0px;
}

/* Style the links inside the navigation bar */
.topnav a {
  float: left;
  display: block;
  color: #9e9e9e!important;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 13px;
	font-family: 'Raleway';
	font-weight: bold;
}
div.login {width: 90%; margin: auto; padding-bottom: 20px;padding-top: 60px;}
div.login2 {width: 90%; margin: auto; border-top: solid 2px #dadada; padding-left: 0px; padding-bottom: 0px;}

.mainsection {
    width: 100%;
    padding-top: 120px;
    padding-right: 0px;
    padding-left: 0px;
}
	.container {
    margin: 0 auto;
    font-size: 14px;
    font-weight: bold;
    color: #231f20;
}
	.bottom-bar2{background-color:#000000!important; padding: 15px 20px 20px 20px;
    bottom:0; width: 100%;}
}


input{
    width: 100%;
    margin-bottom: 5px;
    margin-top: 18px;
}
</style>